class Edge {
  constructor(priorProbability, nextMove, illegal = false) {
    /**
     * Prior probability of selecting this edge: P(s,a)
     */
    this.priorProbability = priorProbability;
    /**
     * Next Move (action)
     */
    this.nextMove = nextMove;
    /**
     * Total action value: W(s,a)
     */
    this.totalActionValue = 0;
    /**
     * Visit count: N(s,a)
     */
    this.visitCount = 0;
    /**
     * True if illegal move
     */
    this.illegal = illegal;
  }

  // not used
  /**
   * Create Edge object from the edge data fetched from IndexedDB.
   * 
   * @param {*} item 
   */
  static from(item) {
    const edge = new Edge(item.priorProbability, item.nextMove);
    edge.totalActionValue = item.totalActionValue;
    edge.visitCount = item.visitCount;
    return edge;
  }

  /**
   * Mean action value: Q(s,a)
   */
  get meanActionValue() {
    return this.visitCount
    ? this.totalActionValue / this.visitCount
    : 0;
  }

  /**
   * Score = Q(s,a) + U(s,a)
   * 
   * @param {*} c level of exploration
   * @param {*} parentVisitCount 
   * @param {*} parentMeanEvaluation
   */
  score(c, parentVisitCount, parentMeanEvaluation) {
    const p = this.priorProbability;
    const n = this.visitCount;
    const pn = parentVisitCount;
    const q = n ? this.meanActionValue : parentMeanEvaluation - 0.1;
    // const u = c * p * Math.log10(1 + pn) / (1 + n);
    const u = c * p * Math.sqrt(pn) / (1 + n); // AlphaGoZero
    const vp = Math.tanh(n / Math.max(pn, 100)) / 4; // many visits penalty
    return q + u - vp;
  }

  toString() {
    return `Edge[nextMove=${this.nextMove}, prior=${this.priorProbability}, ` +
      `totalActionValue=${this.totalActionValue}, visitCount=${this.visitCount}, ` +
      `q=${this.meanActionValue}]`;
  }
}

export default Edge;